import {
  Component,
  DestroyRef,
  effect,
  ElementRef,
  OnDestroy,
  OnInit,
  output,
  viewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
} from "@angular/forms";
import { ClickOutsideDirective } from "blu-utilities";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { AppNotificationService } from "src/app/core/services/app-notification.service";
import { ColorModeService } from "src/app/core/services/color-mode.service";
import { AppService } from "./../../../services/app.service";
import { BaseComponent } from "./../base/base.component";

@Component({
  selector: "app-search-modules",
  templateUrl: "./search-modules.component.html",
  styleUrl: "./search-modules.component.scss",
  imports: [
    AddClassModifierDirective,
    ClickOutsideDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SearchModulesComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  readonly inputItem = viewChild<ElementRef>("inputItem");
  readonly closeClicked = output();

  get closeImage() {
    if (this.colorModeService.isDarkMode) {
      return "/assets/icons/svg/dark/close.svg";
    }
    return "/assets/icons/close.svg";
  }

  constructor(
    appNotificationsService: AppNotificationService,
    private colorModeService: ColorModeService,
    private formBuilder: UntypedFormBuilder,
    private appService: AppService,
    private destroyRef: DestroyRef,
  ) {
    super(appNotificationsService);
    effect(() => {
      const inputItem = this.inputItem();
      inputItem && inputItem.nativeElement.focus();
    });
  }

  ngOnInit(): void {
    this.buildForm();
    this.handleInputChanges();
  }

  buildForm() {
    this.formGroupItem = this.formBuilder.group({
      search: [""],
    });
  }

  handleInputChanges() {
    this.formGroupItem
      ?.get("search")
      ?.valueChanges?.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => {
        this.search(value);
      });
  }

  search(value: string) {
    this.appService.filterNavItems(value);
  }

  close() {
    this.closeClicked.emit();
  }

  ngOnDestroy() {
    this.search("");
  }
}
